import { render } from "./MyReservations.vue?vue&type=template&id=511cddcc&scoped=true"
import script from "./MyReservations.vue?vue&type=script&lang=js"
export * from "./MyReservations.vue?vue&type=script&lang=js"

import "./MyReservations.vue?vue&type=style&index=0&id=511cddcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511cddcc"]])

export default __exports__